<div class="lower-container-wrapper  fluid-container">
  <div class="lower-container container">
    <div class="region region-lower-container">
      <section id="block-calloutsblock" class="block block-cdlsimod block-callouts-content clearfix">
        <div class="callouts-wrapper">
          <div class="callout-wrapper dark-grey-background">
            <div class="image"><img src="./assets/images/pics/Redcar_Front.jpg" alt="" class="img-responsive"></div>
            <div class="title"><h2>{{ "FOOTER_FAQS_TITLE" | translate }}</h2></div>
            <div class="body">{{ "FOOTER_FAQS_BODY" | translate }}</div>
            <div class="link-wrapper">
              <div class="link">
                <a routerLink="/lessees-faq" class="btn btn-callout">{{ "FOOTER_FAQS" | translate }}</a>
              </div>
            </div>
          </div>

          <div class="callout-wrapper dark-grey-background">
            <div class="image" *ngIf="translateService.currentLang==='en'"><img src="./assets/images/pics/Dashboard_Display_en.jpg" alt="" class="img-responsive"></div>
            <div class="image" *ngIf="translateService.currentLang==='fr'"><img src="./assets/images/pics/Dashboard_Display_fr.jpg" alt="" class="img-responsive"></div>
            <div class="title"><h2>{{ "FOOTER_MANAGE_LEASE_TITLE" | translate }}</h2></div>
            <div class="body">{{ "FOOTER_MANAGE_LEASE_BODY" | translate }}</div>            
            <div class="link-wrapper">
              <div class="link">
                <a routerLink="/request-list" class="btn btn-callout">{{ "FOOTER_MANAGE_LEASE" | translate }}</a>
              </div>
            </div>
          </div>         

          <div class="callout-wrapper dark-grey-background">
            <div class="image" *ngIf="translateService.currentLang==='en'"><img src="./assets/images/pics/Dial_English.jpg" alt="" class="img-responsive"></div>
            <div class="image" *ngIf="translateService.currentLang==='fr'"><img src="./assets/images/pics/Dial_French.jpg" alt="" class="img-responsive"></div>
            <div class="title"><h2>{{ "FOOTER_INTENT_TITLE" | translate }}</h2></div>
            <div class="body">{{ "FOOTER_INTENT_BODY" | translate }}</div>            
            <div class="link-wrapper">
              <div class="link">
                <a routerLink="/customer-intent" class="btn btn-callout">{{ "FOOTER_INTENT" | translate }}</a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</div>

<footer class="footer-wrapper container-fluid">
  <div class="container footer-container">
    <div class="region region-footer">

      <section id="block-footercontact" class="footer-flex-item block block-cdlsimod block-footer-contact-content clearfix">      
        <div class="footer-contact-wrappe" *ngIf="translateService.currentLang==='en'">
          <p><strong>Canadian Dealer Lease Services Inc.</strong></p>
          <p>2 Bloor Street West,<br>Suite 700,<br>Toronto, Ontario M4W 3E2</p>
          <p><strong>1.888.703.5765</strong></p>
        </div>
        <div class="footer-contact-wrappe" *ngIf="translateService.currentLang==='fr'">
          <p><strong>Services de location des concessionnaires automobiles canadiens.</strong></p>
          <p>2, rue Bloor Ouest,<br>bureau 700,<br>Toronto (Ontario) M4W 3E2</p>
          <p><strong>1.888.703.5765</strong></p>
        </div>
      </section>

      <nav id="block-mainnavigation" class="footer-flex-item"> 
        <ul class="menu menu--main nav navbar-nav">
          <li class="first">
            <a routerLink="/">{{ "HEADER_HOME" | translate }}</a>
          </li>
          <li>
            <a routerLink="/request-list">{{ "HEADER_REQUESTS" | translate }}</a>
          </li>
          <li>
            <a routerLink="/lessees-faq">{{ "HEADER_FAQ" | translate }}</a>
          </li>          
          <li>
            <a routerLink="/customer-intent">{{ "HEADER_CUSTOMER_INTENT" | translate }}</a>
          </li>          
          <li>
            <a routerLink="/about-us">{{ "HEADER_ABOUTUS" | translate }}</a>
          </li>
          <!-- <li>
            <a routerLink="/join-the-cdlsi-team">{{ "HEADER_CAREERS" | translate }}</a>
          </li> -->
          <li class="last">
            <a routerLink="/contact-us">{{ "HEADER_CONTACT" | translate }}</a>
          </li>
        </ul>
      </nav>
      
      <section id="block-footerprivacy" class="block block-cdlsimod block-footer-privacy-content clearfix">
        <ul class="menu menu--footer nav">
          <li class="first">
            <a routerLink="/privacy-policy">{{ "HEADER_PRIVACY_POLICY" | translate }}</a>
          </li>
          <li>
            <a routerLink="/aoda-multi-year-accessibility-plan">{{ "HEADER_AODA" | translate }}</a>
          </li>
          <li>
            <a routerLink="/accessible-customer-service-policy">{{ "HEADER_ACCESSIBLE_POLICY" | translate }}</a>
          </li>
          <li class="last" *ngIf="translateService.currentLang==='en'">
            <a href="javascript:" hreflang="fr" lang="fr" title="Switch language" (click)="changeLanguage('fr')">Français</a>
          </li>
          <li class="last" *ngIf="translateService.currentLang==='fr'">
            <a href="javascript:" hreflang="en" lang="en" title="Switch language" (click)="changeLanguage('en')">English</a>
          </li>
        </ul>
      </section>

      <section id="block-footercopyright" class="footer-flex-item block block-cdlsimod block-footer-copyright-content clearfix">
          <!-- <div class="chat-button-wrapper" id="footerChat">
            <a href="javascript:void(0);" id="chatIcon" style="border:none;" class="footerChatIcon" (click)="startChat()"><img alt="Live Chat Icon" src="./assets/images/icons/chat_icon.svg"></a>
          </div> -->

          <p>{{ "FOOTER_COPYRIGHT" | translate }}</p>
      </section>

    </div>
  </div>
</footer>



